customElements.define('sticky-atc', class extends HTMLElement {
    constructor() {
        super();
        this.regular = document.querySelector('.section-buy_buttons-margin');
        this.sticky = this;
        this.isMobile = window.matchMedia('(max-width: 767px)');
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleScroll() {
        if (this.isMobile.matches) {
            // Always show on mobile
            this.classList.remove('hide');
            return;
        }

        if(this.regular) {
            const rect = this.regular.getBoundingClientRect();
            // Check if we've scrolled past the regular form
            const scrolledPast = rect.bottom <= 0;
            
            if (scrolledPast) {
                this.classList.remove('hide');
            } else {
                this.classList.add('hide');
            }
        }
    }

    handleResize() {
        if (this.isMobile.matches) {
            this.classList.remove('hide');
        } else {
            this.handleScroll();
        }
    }

    connectedCallback() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        // Initial check
        this.handleResize();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
});